import PatientManagementRouting from './PatientManagment.routing';

export default PatientManagementRouting;
